import { StateCreator, } from "zustand";
import { clearPassport, } from "../../components/features/LoginPage/PassportForm/utils";

export enum EPassportFormState {
  initial,
  validating,
  validated,
  submitting,
  submitted,
}

export const PASSPORT_RF = "PASSPORT_RF";
export const PASSPORT_FOREIGN = "PASSPORT_FOREIGN";
export type TRadioOption =
  | typeof PASSPORT_RF
  | typeof PASSPORT_FOREIGN;

export interface IPassportFormSlice {
  passportType: TRadioOption | null;
  passportNumber: string;
  setPassportType: (v: TRadioOption | null) => void;
  setPassportNumber: (v: string) => void;
  setOptionError: (msg: string) => void;
  setTextError: (msg: string) => void;
  setFormState: (s: EPassportFormState) => void;
  clearForm: () => void;
  errorMessageOption: string;
  errorMessageText: string;
  formState: EPassportFormState;
  getEscapedPassportNumber: () => string;
}

/**
 * Contains all information about passport form.
 */
export const passportFormSliceCreator: StateCreator<IPassportFormSlice> = (set, get) => ({
  passportType: "PASSPORT_RF",
  passportNumber: "",

  formState: EPassportFormState.initial,
  errorMessageOption: "",
  errorMessageText: "",

  setPassportType: (v,) => {
    set(() => ({
      passportType: v,
      errorMessageOption: "", // сбрасываем ошибку при выборе
    }),);
  },
  setPassportNumber: (v,) => {
    set(() => ({
      passportNumber: v.slice(0, 64,), // мягкий лимит длины (пример)
      errorMessageText: "",
    }),);
  },
  setFormState: (s,) => {
    set(() => ({ formState: s, }),);
  },
  setOptionError: (msg,) => {
    set(() => ({ errorMessageOption: msg, }),);
  },
  setTextError: (msg,) => {
    set(() => ({ errorMessageText: msg, }),);
  },
  clearForm: () => {
    set(() => ({
      passportType: null,
      passportNumber: "",
      formState: EPassportFormState.initial,
      errorMessageOption: "",
      errorMessageText: "",
    }),);
  },
  getEscapedPassportNumber: () => {
    return clearPassport(get().passportNumber,);
  },
});
